import * as React from "react";

import { RegisterOptions, UseControllerProps } from "react-hook-form";

import { mergeValidators } from "@/helpers/validators";

export const useValidators = (rules?: RegisterOptions[]): UseControllerProps["rules"] => {
  return React.useMemo(() => mergeValidators(...(rules ?? [])), [rules]);
};
